import { Card, Link, LinkButton } from '@oriola-corporation/ui-components';

import { Header } from './Header/Header';

export const Support = () => {
  return (
    <div>
      <Header>APOTEKSSUPPORT</Header>
      <Card>
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-2">
            <h3 className="font-bold">
              För e-handelsfrågor, Click & Collect, kundgarantier och reklamationer:
            </h3>
            <p>Telefonnummer: 010-10 291 41</p>
            <p>Användning: Endast för intern användning. Detta nummer ges ej ut till kunder.</p>
          </div>
          <div className="flex flex-col gap-2">
            <h3 className="font-bold">Vid akuta stängningar:</h3>
            <div className="flex flex-col gap-2">
              <p>Telefonnummer: 010-10 291 42</p>
              <p>Användning: Endast för intern användning. Detta nummer ges ej ut till kunder.</p>
            </div>
          </div>

          <LinkButton href="https://pharmacysupport.refined.site/" target="_blank">
            Anmäl supportärende
          </LinkButton>
          <Link
            target="_blank"
            href="https://kronansapotekab.sharepoint.com/SitePages/Support.aspx"
          >
            Mer information och öppettider finns på Kronet
          </Link>
        </div>
      </Card>
    </div>
  );
};
